// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import laoJson from "./messages/lao.json"
import enJson from "./messages/en.json"
import chiJson from "./messages/china.json"

const resources = {
    en: {
        translation: enJson,
    },
    lao: {
        translation: laoJson,
    },
    chi: {
        translation: chiJson,
    },

};

i18n
    .use(LanguageDetector) // Detects the user's language
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: 'lao', // Use English if the detected language is not available
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export default i18n;
